import React, { useContext, useReducer } from 'react'
export const BrowseContext = React.createContext({})

const initialState = {
  personalizedWorkout: [],
  latestWorkout: {},
  minePrograms: [],
  browsePart2: [],
  browsePart3: [],
  meals: [],
  weightSummary: null,
  recommendProgramList: [],
}

const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_BROWSE':
      return {
        ...state,
        ...(action.payload || {}),
      }
    default:
      throw new Error()
  }
}

export const BrowseContextProvider = (Children) => {
  const Provider = (props) => {
    const [state, dispatch] = useReducer(reducer, initialState)

    return (
      <BrowseContext.Provider value={{ ...state, dispatch }}>
        <Children {...props} />
      </BrowseContext.Provider>
    )
  }
  return Provider
}

export const useBrowseContext = () => {
  const {
    personalizedWorkout,
    latestWorkout,
    minePrograms,
    browsePart2,
    browsePart3,
    meals,
    weightSummary,
    recommendProgramList,
    dispatch,
  } = useContext(BrowseContext)

  const setBrowse = (payload) => {
    dispatch({
      type: 'SET_BROWSE',
      payload,
    })
  }

  return {
    personalizedWorkout,
    latestWorkout,
    minePrograms,
    browsePart2,
    browsePart3,
    meals,
    weightSummary,
    recommendProgramList,
    setBrowse,
  }
}
